export default __webpack_public_path__ + "static/media/myjourney-greentree-nut.a0044cdf.svg";